module.exports = __webpack_public_path__ + "img/culture_img3.f92fd9da.jpg";